/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

// Import from application
import InCourseSearchBar from 'bundles/in-course-search/components/SearchBar';

const styles = {
  styleFixes: css`
    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
    }
  `,
};

const InCourseSearchGridItem = ({ referrer, isInternal }: { referrer?: string; isInternal?: boolean }) => {
  return (
    <span css={styles.styleFixes}>
      <InCourseSearchBar referrer={referrer} isInternal={isInternal} />
    </span>
  );
};

export default InCourseSearchGridItem;
